'use es6';

import keyMirror from 'react-utils/keyMirror';
export default Object.freeze(keyMirror({
  IN_PROGRESS: null,
  FAILED: null,
  ENQUEUED: null,
  COMPLETE: null,
  UNINITIALIZED: null
}));